export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de campos"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "module_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calidad"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to the list of crop fields"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])},
          "module_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality"])}
        }
      }
    }
  })
}